import {
  forwardRef,
  type MouseEventHandler,
  type PropsWithChildren,
} from "react";

import { Checkbox } from "../../atoms";
import type { TableRowCheckboxProps } from "./TableRowCheckbox.types";

const TableRowCheckbox = forwardRef<
  HTMLDivElement,
  PropsWithChildren<TableRowCheckboxProps>
>(({ row, table, lastSelectedRow, handleSetLastSelectedRow }, forwardedRef) => {
  const handleCheckboxClick: MouseEventHandler<HTMLInputElement> = (e) => {
    e.stopPropagation();

    if (e.shiftKey) {
      const { rows } = table.getRowModel();
      const lastSelectedIndex = lastSelectedRow.index;
      const isCurrentRowSelected = row.getIsSelected();

      if (lastSelectedIndex >= 0) {
        const [minIndex, maxIndex] =
          lastSelectedIndex < row.index
            ? [lastSelectedIndex, row.index]
            : [row.index, lastSelectedIndex];

        for (const row of rows) {
          if (row.index >= minIndex && row.index <= maxIndex) {
            row.toggleSelected(!isCurrentRowSelected);
          }
        }
      }
    }
  };

  const handleCustomChange = () => {
    const isSelected = row.getIsSelected();
    row.toggleSelected();
    handleSetLastSelectedRow(row.index, isSelected);
  };

  return (
    <div className="ml-4" ref={forwardedRef}>
      <Checkbox
        className="size-4 hover:cursor-pointer"
        checked={row.getIsSelected()}
        onChange={handleCustomChange}
        onClick={handleCheckboxClick}
      />
    </div>
  );
});

TableRowCheckbox.displayName = "TableRowCheckbox";

export default TableRowCheckbox;
